export default __webpack_public_path__ + "static/media/rosemontremotelogowhite-01.94545400.png";